function veda_fn_985f4819429845a88852486028e0c511 () {
      
  if (window.veda_fn_985f4819429845a88852486028e0c511Cleanup === undefined) {
    window.veda_fn_985f4819429845a88852486028e0c511Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_985f4819429845a88852486028e0c511Cleanup.cleanup();

      try {
        const uniqueId = "id_8023c0a1-19eb-416f-997a-9527d1ee28b4";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { countdown } = veda.plugins;
const countdownEls = container.querySelectorAll(".veda-countdown");

countdownEls.forEach((countdownEl) => {
  const destroy = countdown(countdownEl);
  window.veda_fn_985f4819429845a88852486028e0c511Cleanup.push(() => {
    destroy();
  });
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_985f4819429845a88852486028e0c511();
function veda_fn_cc7c5a3925a54c11a55fa13e664261cf () {
      
  if (window.veda_fn_cc7c5a3925a54c11a55fa13e664261cfCleanup === undefined) {
    window.veda_fn_cc7c5a3925a54c11a55fa13e664261cfCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_cc7c5a3925a54c11a55fa13e664261cfCleanup.cleanup();

      try {
        const uniqueId = "id_feedefaf-42a5-4f25-b3e7-905b65eb5224";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);
videoButtonEls.forEach((videoButtonEl) => {
  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }
  videoButtonEl.addEventListener("click", handleClick);
  window.veda_fn_cc7c5a3925a54c11a55fa13e664261cfCleanup.push(() => {
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_cc7c5a3925a54c11a55fa13e664261cfCleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_cc7c5a3925a54c11a55fa13e664261cf();
function veda_fn_e82d98f750d74d7eaa1d0e015039d3ae () {
        
  if (window.veda_fn_e82d98f750d74d7eaa1d0e015039d3aeCleanup === undefined) {
    window.veda_fn_e82d98f750d74d7eaa1d0e015039d3aeCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_e82d98f750d74d7eaa1d0e015039d3aeCleanup.cleanup();

        try {
          const uniqueIds = ["id_ad89dbd2-fdc9-4b7d-ae8c-7bb4c599f533","id_68afdac4-17c3-470c-be34-237bbf3193a0","id_208c7ba5-8cf1-47d3-b73b-3a10126e794e","id_c65e8ead-9118-42a6-bebd-128568bdc289","id_527ac212-c38b-48ba-bda4-ec8533b3099f","id_d6b8a907-e7f2-4b33-9feb-65d1a465836e","id_527ac212-c38b-48ba-bda4-ec8533b3099f","id_d6b8a907-e7f2-4b33-9feb-65d1a465836e"];
          uniqueIds.forEach(uniqueId => {
            const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
            containers.forEach(container => {
              if (!container) {
                return;
              }
              veda.plugins.videoCover(container);
              
            });
          });
        } catch(error) {
          console.error(error);
        }
      }
veda_fn_e82d98f750d74d7eaa1d0e015039d3ae();
function veda_fn_b2932707343b4f1f88e20e4da0f040d4 () {
      
  if (window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup === undefined) {
    window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup.cleanup();

      try {
        const uniqueId = "id_d5c97e44-bdef-4b6a-bf4a-f46598362829";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { offset } = veda.utils;
const { backgroundParallax } = veda.plugins;
const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);
const parallaxEls = container.querySelectorAll(".veda-parallax-js");

function checkPointInCircle(x, y, cx, cy, r) {
  return Math.pow(x - cx, 2) + Math.pow(y - cy, 2) <= Math.pow(r, 2);
}

if (document.querySelector(`body > .veda-videos-${uniqueId}-js`)) {
  document.querySelector(`body > .veda-videos-${uniqueId}-js`).remove();
}
document.body.appendChild(videosEl);

parallaxEls.forEach((parallaxEl) => {
  const speed = parallaxEl.getAttribute("data-parallax-speed");
  const destroy = backgroundParallax(parallaxEl, {
    speed: speed ?? 0.3,
  });
  window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup.push(() => {
    destroy();
  });
});
function isYoutube(url) {
  return url.search(/^https?:\/\/(www|)\.youtube\.com/g) !== -1;
}

function isVimeo(url) {
  return url.search(/^https?:\/\/(player\.|)vimeo\.com/g) !== -1;
}

videoButtonEls.forEach((videoButtonEl) => {
  const childEl = videoButtonEl.querySelector(".veda-video-button-child-js");
  let r = 150;

  function handleMouseMove(event) {
    const { top, left, width, height } = videoButtonEl.getBoundingClientRect();
    const cx = left + width / 2;
    const cy = top + height / 2;
    const lx = Math.max(cx - event.clientX, 0);
    const rx = Math.max(event.clientX - cx, 0);
    const ty = Math.max(cy - event.clientY, 0);
    const by = Math.max(event.clientY - cy, 0);
    const c = 1.3;

    if (checkPointInCircle(event.clientX, event.clientY, cx, cy, r)) {
      r = 200;
      let translateX = 0;
      let translateY = 0;
      if (lx > 0) {
        translateX = lx / -c;
      } else if (rx > 0) {
        translateX = rx / c;
      }
      if (ty > 0) {
        translateY = ty / -c;
      } else if (by > 0) {
        translateY = by / c;
      }
      childEl.style.transform = `translate(${translateX}px, ${translateY}px)`;
    } else {
      r = 150;
      childEl.style.transform = `translate(0, 0)`;
    }
  }

  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      if (isYoutube(src) || isVimeo(src)) {
        embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      } else {
        embedEl.innerHTML = `<video src="${src}" loop muted autoplay style="position: absolute;top:0;left:0;width:100%"></video>`;
      }
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }

  document.addEventListener("mousemove", handleMouseMove);
  videoButtonEl.addEventListener("click", handleClick);

  window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup.push(() => {
    document.removeEventListener("mousemove", handleMouseMove);
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_b2932707343b4f1f88e20e4da0f040d4Cleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_b2932707343b4f1f88e20e4da0f040d4();